import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        variant: { type: String, default: 'primary' },
        disabled: { type: Boolean },
    },
});
